/**
 * Logs Vite `import.meta.env` (MODE, BASE_URL, and all `VITE_*` keys).
 * Dev: always. Prod/preview: only if `VITE_LOG_ENV=true` (e.g. temporary debugging).
 */
export function logViteEnv() {
  const env = import.meta.env;
  const shouldLog =
    env.DEV === true || String(env.VITE_LOG_ENV).toLowerCase() === 'true';
  if (!shouldLog) return;

  /** Plain snapshot — `import.meta.env` is a Vite proxy; stringify for readable console output. */
  const snapshot = Object.fromEntries(
    Object.keys(env)
      .sort()
      .map((key) => [key, env[key]]),
  );

  // eslint-disable-next-line no-console -- intentional env debug
  console.info(
    `[QC Lite] import.meta.env (${Object.keys(snapshot).length} keys)\n${JSON.stringify(snapshot, null, 2)}`,
  );
}
